<script setup lang="ts">
interface Props {
  /** Checklist item text */
  item: string
  /** Icon to display */
  icon?: string
  /** Icon color */
  color?: string
}

const { icon = '$check', color = 'success' } = defineProps<Props>()

defineOptions({
  name: 'CheckListItem'
})
</script>

<template>
  <li class="flex flex-row items-center gap-2">
    <VIcon :color :icon size="1.5rem" class="p-1" />
    <slot :item>
      <span class="leading-5">{{ item }}</span>
    </slot>
  </li>
</template>
